import React from 'react'

import { plainValueCodec } from '../pathMapping/paths'
import { TokenListFields } from '../pathMapping/TokenListFields'

/**
 * The values at the event-type path that mean "started" or "stopped".
 *
 * These are literal vendor values, not paths, so the row uses plainValueCodec.
 */
export const GenericEventValuesFields = ({ field, label, caption, testIdPrefix, placeholder }) => (
  <TokenListFields
    field={field}
    label={label}
    codec={plainValueCodec}
    testIdPrefix={testIdPrefix}
    columnLabels={['Value']}
    addLabel="Add value"
    removeLabel={`Remove ${label}`}
    placeholder={placeholder}
    caption={caption}
  />
)
